var _ellipse, _path, _path2, _ellipse2, _path3, _path4, _ellipse3, _path5, _path6, _ellipse4, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle2, _ellipse5, _ellipse6, _ellipse7, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWomanWithCatBlueIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 786.295 749.197"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 428.295,
  cy: 670.89,
  fill: "#3f3d56",
  rx: 358,
  ry: 40
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m605.842 626.63 6.174 19.023s29.736 30.72 18.981 39.047-34.884-35.568-34.884-35.568l-4.447-21.476Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m548.795 479.39 9-3s14 4 16 18 17 85 17 85 6 3 2 8 20 50 20 50l-19 9s-38-40-38-44 1-8 1-12-1-4 0-7a32.2 32.2 0 0 0 1-8l-7-16Z"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 90.418,
  cy: 363.498,
  fill: "#ffbd01",
  rx: 90.418,
  ry: 184.489
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M89.588 365.411c4.51-80.306 13.597-134.551 13.689-135.09l-1.972-.334c-.091.54-9.195 54.871-13.712 135.281-4.17 74.214-5.175 186.467 13.711 299.786l1.973-.328C84.423 551.6 85.426 439.516 89.587 365.411"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m89.478 369.84 81.752-43.756.944 1.764-81.752 43.755zM3.176 349.777l.943-1.763 81.764 43.734-.944 1.763z"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 304.565,
  cy: 252.458,
  fill: "#e6e6e6",
  rx: 123.73,
  ry: 252.458
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M303.062 255.045c6.173-109.912 18.611-184.152 18.736-184.89l-1.972-.334c-.125.738-12.579 75.066-18.759 185.08-5.704 101.538-7.08 255.118 18.759 410.153l1.973-.328c-25.808-154.844-24.434-308.253-18.737-409.681"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m303.453 261.461 111.871-59.876.944 1.763-111.87 59.877zM185.355 233.358l.943-1.763 111.887 59.846-.943 1.764z"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 201.491,
  cy: 508.968,
  fill: "#e6e6e6",
  rx: 46.229,
  ry: 94.325
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m201.45 513.032.274.512 41.798-22.373-.943-1.763-41.041 21.967c2.271-41.802 6.916-69.863 7.01-70.415l-1.972-.334c-.102.603-5.621 33.926-7.58 82.144l-41.394-22.155-.943 1.764 41.798 22.372.499-.933c-1.568 39.797-.689 89.56 7.62 139.41l1.972-.328c-9.059-54.352-9.258-108.603-7.097-149.868"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M561.031 384.464c-16.074-27.395-47.876-28.672-47.876-28.672s-30.988-3.997-50.867 37.726c-18.53 38.89-44.101 76.44-4.117 85.543l7.222-22.674 4.473 24.362a155 155 0 0 0 17.108.295c42.82-1.394 83.599.408 82.286-15.09-1.746-20.604 7.238-55.13-8.229-81.49M448.99 603.9a61 61 0 0 1-1.95 8.463c-.956 2.712-2.432 5.22-3.306 7.96-2.787 8.733 1.076 18.471 7.246 25.213a40.7 40.7 0 0 0 19.888 11.911c5.566 1.412 11.354 1.615 17.09 1.812 15.885.543 32.178 1.029 47.23-4.12a81.7 81.7 0 0 0 13.722-6.288 10.3 10.3 0 0 0 3.56-2.827c1.148-1.649 1.295-3.787 1.285-5.801-.034-6.793-1.4-13.55-1.075-20.334.18-3.758.877-7.513.534-11.26a20.71 20.71 0 0 0-15.738-17.891c-4.27-.925-8.699-.421-13.046 0a330 330 0 0 1-33.951 1.532c-11.582-.075-23.093-1.858-34.617-2.045-3.409-.055-3.34 1.005-4.425 4.332a82 82 0 0 0-2.448 9.342"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M403.7 598.379a34 34 0 0 0-9.534-1.022 24.06 24.06 0 0 0-17.379 9.113 24.5 24.5 0 0 0-4.71 19.178 40.5 40.5 0 0 0 3.777 10.411c2.528 5.175 5.56 10.339 10.24 13.655a39.7 39.7 0 0 0 9.038 4.34l24.65 9.366c3.627 1.378 7.254 2.756 10.916 4.033a212 212 0 0 0 57.013 11.433c5.919.355 11.928.454 17.702-.905a5.75 5.75 0 0 0 3.625-1.976 6.3 6.3 0 0 0 .81-2.698l1.517-10.71a9.05 9.05 0 0 0-.129-4.516c-.695-1.8-2.436-2.933-4.097-3.895-16.206-9.388-35.128-14.568-48.769-27.453-3.211-3.033-5.898-7.842-9.8-9.902-4.424-2.337-9.635-3.67-14.208-5.824-9.998-4.707-19.827-10.116-30.663-12.628"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M428.309 612.818c8.713 2.754 45.498 21.833 51.804 28.494-.846.307-29.52-15.902-30.381-16.163-7.821-2.367-15.686-4.75-23.114-8.216-1.494-.697-9.707-3.973-9.335-5.875.42-2.145 9.48 1.272 11.026 1.76",
  opacity: 0.1
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M537.007 684.44a2.03 2.03 0 0 0 1.381-.41 2.17 2.17 0 0 0 .432-1.602l-.04-14.592c-4.16-2-8.814-2.64-13.381-3.256l-21.312-2.873c.49.066-3.332 9.258-2.746 10.485 1.033 2.163 8.926 4.08 11.154 5.101 7.743 3.55 15.79 7.454 24.512 7.148"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M470.143 667.785c-4.023.647-8.514 1.218-11.12 4.377-3.305 4.007-1.898 9.98-.322 14.943a6.45 6.45 0 0 0 1.371 2.719c1.076 1.07 2.725 1.227 4.233 1.323 3.67.235 7.575.418 10.78-1.397a47 47 0 0 0 4.189-3.14 26.7 26.7 0 0 1 7.7-3.551 77.3 77.3 0 0 1 15.456-3.213 23.9 23.9 0 0 0 6.09-1.083 6.77 6.77 0 0 0 4.287-4.199c.743-2.652-.785-5.355-2.25-7.68-1.826-2.898-3.76-5.948-6.482-8.08-3.97-3.112-5.935-.724-9.935 1.267a83.8 83.8 0 0 1-23.997 7.714"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m459.628 671.44-25.55-7.616a33.6 33.6 0 0 0-9.507-1.858c-3.24.002-6.63 1.074-8.732 3.561-1.98 2.346-2.548 5.551-3.042 8.592l-1.056 6.504a33 33 0 0 0-.592 9.989c.483 3.314 2.16 6.624 5.076 8.229 3.535 1.945 7.869.995 11.814.181a127.6 127.6 0 0 1 24.212-2.619c3.058-.037 6.266.002 8.968-1.443 3.212-1.717 5.134-5.348 5.465-9 .502-5.556-1.334-12.813-7.056-14.52M547.05 664.803c3.312-.585 6.235-2.484 9.41-3.605 4.466-1.577 9.307-1.577 14.04-1.56 1.738.007 3.588.046 5.034 1.017 2.085 1.4 2.62 4.202 2.974 6.703l2.139 15.088c.402 2.838.802 5.752.174 8.548s-2.517 5.492-5.268 6.213c-3.34.876-6.616-1.277-9.77-2.69-7.884-3.535-17.05-2.632-25.27-5.273-1.526-.49-3.16-1.24-3.782-2.728a6.3 6.3 0 0 1-.295-2.608c.141-4.85-.873-11.472.575-16.107 1.302-4.169 6.342-2.998 10.04-2.998"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M601.118 592.306a44 44 0 0 1 15.63-1.077c4.178.464 8.483 1.637 11.533 4.554 3.713 3.55 4.906 9.041 5.006 14.2a44.6 44.6 0 0 1-9.56 28.335 25.6 25.6 0 0 1-5.467 5.308 36 36 0 0 1-7.111 3.456l-55.204 21.963c-14.522 5.777-29.096 11.572-44.244 15.38a3.436 3.436 0 0 1-4.64-1.696 115.7 115.7 0 0 1-12.1-22.324 2.02 2.02 0 0 1-.155-1.672 2 2 0 0 1 .815-.7l39.045-22.628a39.5 39.5 0 0 0 7.948-5.523 19.9 19.9 0 0 0 4.08-5.73c.81-1.705.885-5.729 1.919-6.99 1.012-1.233 4.474-1.332 6.073-1.817a55 55 0 0 0 6.613-2.521c8.734-3.941 16.512-9.668 24.885-14.283a63.6 63.6 0 0 1 14.934-6.235"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M578.983 609.205c-6.709 5.082-15.394 9.753-22.043 14.969-2.27 1.78-40.095 23.23-40.63 26.08 6.203 1.053 45.715-26.827 51.368-29.61s10.664-6.705 15.63-10.6c1.266-.992 6.629-3.975 2.996-5.084-2.047-.624-5.81 3.229-7.321 4.245",
  opacity: 0.1
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 511.795,
  cy: 415.39,
  r: 38,
  fill: "#ffb8b8"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M527.795 447.39s-6 15 5 21-34 54-34 54l-20-58s17-6 14-22Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m502.795 488.39 24.218-26.735 32.782 16.735-5 118-8 9s-34 30-86 5c0 0-18-15-17-38s-2-26-2-26l-1-81 49.37-9.688Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m391.748 615.63-6.175 19.023s-29.736 30.72-18.98 39.047 34.883-35.568 34.883-35.568l4.447-21.476Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m448.795 468.39-9-3s-14 4-16 18-17 85-17 85-6 3-2 8-20 50-20 50l19 9s38-40 38-44-1-8-1-12 1-4 0-7a32.2 32.2 0 0 1-1-8l7-16Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m553.925 381.823-31.419-16.599-43.387 6.79-8.977 39.991 22.346-.867 6.242-14.692v14.449l10.311-.4 5.985-23.39 3.74 24.9 36.655-.755z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff6584",
  d: "M331.205 639.08v57.68h-176.18a57.683 57.683 0 0 1 57.68-57.68c16.52-5.15 35.62-6.79 56.34-6.25 19.55.5 40.54 2.95 62.16 6.25"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M306.037 684.178h82.847a5.244 5.244 0 0 1 5.244 5.243 5.244 5.244 0 0 1-5.244 5.244h-82.847zM320.386 589.718l22.206-26.918a5.83 5.83 0 0 1 10.865.931l8.757 30.918Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff6584",
  d: "m293.453 603.428 8.39-33.873a5.83 5.83 0 0 1 10.2-3.856l21.26 24.095ZM155.024 696.762h16.78v35.656a16.78 16.78 0 0 1-16.78 16.78zM302.89 686.275h82.848a5.244 5.244 0 0 1 5.244 5.244 5.244 5.244 0 0 1-5.244 5.243h-82.847z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M331.205 639.08v57.36a56.645 56.645 0 0 1-62.16-63.61c19.55.5 40.54 2.95 62.16 6.25",
  opacity: 0.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 331.206,
  cy: 640.132,
  r: 56.63,
  fill: "#ff6584"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 385.738,
  cy: 644.327,
  fill: "#3f3d56",
  rx: 6.292,
  ry: 14.682
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 370.532,
  cy: 629.121,
  fill: "#3f3d56",
  rx: 1.573,
  ry: 3.67
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 382.068,
  cy: 621.78,
  fill: "#3f3d56",
  rx: 1.573,
  ry: 3.67
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M326.455 582.872s-3.148-5.475-3.148-8.815M327.84 579.33s1.714-6.077 4.103-8.412"
})));
export default SvgWomanWithCatBlueIcon;